import React from "react";
import { divIcon } from "leaflet";
import {
  MapContainer as LeafletMap,
  TileLayer,
  WMSTileLayer,
  Marker,
  Tooltip,
  ScaleControl,
  ZoomControl,
  GeoJSON,
} from "react-leaflet";
import styled from "styled-components";

import "./MapContainer.css";
import KOREA_MAP from "../data/map/KOREA-MAP-V3.json";
import { MAP_URLS } from "../data/basicStructure";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const DEFAULT_CENTER = [35.9078, 130.0];
const DEFAULT_ZOOM = 7;

const AlimtalkMapContainer = ({ totalSpots = [], selectSpot }) => {
  const onEachFeature = (feature, layer) => {
    layer.on({ mouseover: () => {}, mouseout: () => {}, click: () => {} });
  };

  return (
    <Wrapper>
      <LeafletMap
        center={DEFAULT_CENTER}
        zoom={DEFAULT_ZOOM}
        minZoom={6}
        style={{ width: "100%", height: "100%" }}
        zoomControl={false}
      >
        <ZoomControl position="bottomleft" />
        <ScaleControl metric={true} imperial={false} />
        <TileLayer url={MAP_URLS.satellite} attribution="VWORLD" />
        <WMSTileLayer url={MAP_URLS.hybrid} />
        {totalSpots.map((spot) => {
          return (
            <Marker
              key={spot.id ?? `${spot.region}-${spot.latitude}-${spot.longitude}`}
              position={[spot.latitude, spot.longitude]}
              eventHandlers={{ click: () => selectSpot && selectSpot(spot) }}
              icon={divIcon({
                className: "",
                iconSize: [24, 24],
                html: `<div style="background:${spot.is_same.color}; opacity:0.8; width:24px; height:24px; border-radius:50%;"></div>`,
              })}
            >
              <Tooltip>
                <div>
                  <strong>{`${spot.regionName}-${spot.name}` ?? "-"}</strong>
                  <br />
                  지점 코드: {spot.code ?? "-"}
                  <br />
                  총 발송차수: {spot.total ?? "-"}차 / 현재 발송차수: {spot.now ?? "-"}차
                  <br />
                  최근 발송일자: {spot.recentSentDt ?? "-"}
                </div>
              </Tooltip>
            </Marker>
          );
        })}
        <GeoJSON
          color="black"
          weight={2}
          opacity={0.5}
          fillColor="white"
          data={KOREA_MAP}
          onEachFeature={onEachFeature}
        />
      </LeafletMap>
    </Wrapper>
  );
};

export default AlimtalkMapContainer;
